import React from "react";
import { Send } from "lucide-react";
import { trackTelegramClick } from "../lib/analytics";

/**
 * Floating Telegram chat widget — primary support channel.
 *  • Mobile (< sm): compact vertical sticky widget at top-right with icon
 *    stacked above a single-line "CHAT NOW" label.
 *  • Desktop (≥ sm): minimal pill button bottom-right with icon + "CHAT NOW".
 *
 * Orders go via email through Checkout; this widget is for quick support only.
 */
export const TelegramButton = () => {
    const href = "https://t.me/QuantumGenesisLabs";

    return (
        <>
            {/* MOBILE: top-right sticky vertical widget */}
            <a
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Chat with us on Telegram"
                data-testid="telegram-mobile-widget"
                onClick={() => trackTelegramClick("mobile-sticky")}
                className="
                    sm:hidden fixed top-[124px] right-3 z-40
                    group flex flex-col items-center justify-center
                    w-[68px] py-3 px-2 rounded-2xl
                    bg-[#0A0A12]/80 backdrop-blur-xl
                    border border-indigo-500/35
                    text-center
                    transition-all duration-300 ease-out
                    active:scale-95
                    tg-luxury-pulse
                "
            >
                {/* gradient halo */}
                <span className="pointer-events-none absolute inset-0 rounded-2xl bg-gradient-to-b from-indigo-500/15 via-transparent to-violet-500/15" />

                <span className="relative flex items-center justify-center w-8 h-8 rounded-full bg-gradient-to-br from-indigo-500 to-violet-600 shadow-[0_0_22px_rgba(99,102,241,0.6)]">
                    <Send className="w-4 h-4 text-white -translate-x-[1px] translate-y-[1px]" strokeWidth={2.4} />
                    <span className="pointer-events-none absolute inset-0 rounded-full ring-1 ring-white/15" />
                </span>

                <span className="relative mt-2 text-[10px] font-semibold tracking-[0.18em] text-slate-100 uppercase leading-none">
                    Chat Now
                </span>
            </a>

            {/* DESKTOP: bottom-right pill */}
            <a
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Chat with us on Telegram"
                data-testid="telegram-floating-button"
                onClick={() => trackTelegramClick("desktop-floating")}
                className="
                    hidden sm:inline-flex group fixed z-40 bottom-7 right-7
                    items-center justify-center gap-3
                    rounded-full pl-2 pr-6 py-2
                    bg-[#0A0A12]/85 hover:bg-[#0F0F1A]/95 backdrop-blur-xl
                    border border-indigo-500/35 hover:border-indigo-400/65
                    text-slate-100 text-sm font-semibold tracking-[0.16em] uppercase
                    transition-all duration-300 ease-out
                    hover:-translate-y-0.5 active:translate-y-0
                    tg-luxury-pulse
                "
            >
                <span className="relative flex items-center justify-center w-9 h-9 rounded-full bg-gradient-to-br from-indigo-500 to-violet-600 shadow-[0_0_22px_rgba(99,102,241,0.55)]">
                    <Send className="w-4 h-4 text-white -translate-x-[1px] translate-y-[1px]" strokeWidth={2.4} />
                    <span className="pointer-events-none absolute inset-0 rounded-full ring-1 ring-white/15" />
                </span>
                <span className="leading-none pb-[1px]">Chat Now</span>
            </a>
        </>
    );
};

export default TelegramButton;
